import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import sagas from '../sagas/rootSaga';
import rootReducer from '../reducers/rootReducer';
import { AppState } from './types/Store';

export default function configureStore(initialState: AppState, history: unknown) {
  const sagaMiddleware = createSagaMiddleware();
  const routerMW = routerMiddleware(history);

  const store = createStore(
    rootReducer,
    initialState,
    composeWithDevTools(applyMiddleware(sagaMiddleware, thunk, routerMW))
  );

  // Run sagas
  sagaMiddleware.run(sagas);

  return store;
}

export type RootStore = ReturnType<typeof configureStore>